<section class="slot-board" [attr.aria-labelledby]="boardLabelledBy()">
  @if (heading()) {
    <h3 [id]="boardLabelledBy()">{{ heading() | translate }}</h3>
  }
  @if (loading() && !snapshot()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (errorMessage() && !snapshot()) {
    <div class="error-message">{{ errorMessage() | translate }}</div>
  } @else {
    @if (snapshot(); as current) {
      @if (errorMessage()) {
        <div class="error-message">{{ errorMessage() | translate }}</div>
      }
      <dl>
        <div>
          <dt>{{ 'Used connections' | translate }}</dt>
          <dd>{{ current.usedConnections }} / {{ current.maxConnections }}</dd>
        </div>
        <div>
          <dt>{{ 'Remaining application slots' | translate }}</dt>
          <dd>{{ current.remainingApplicationSlots }}</dd>
        </div>
        <div>
          <dt>{{ 'Slot pressure' | translate }}</dt>
          <dd>
            <app-status-tag [color]="pressureColor()" [label]="pressureLabel()"></app-status-tag>
          </dd>
        </div>
        <div>
          <dt>{{ 'Active' | translate }}</dt>
          <dd>{{ current.activeConnections }}</dd>
        </div>
        <div>
          <dt>{{ 'Idle' | translate }}</dt>
          <dd>{{ current.idleConnections }}</dd>
        </div>
        <div>
          <dt>{{ 'Idle in transaction' | translate }}</dt>
          <dd>{{ current.idleInTransactionConnections }}</dd>
        </div>
        <div>
          <dt>{{ 'Waiting on server' | translate }}</dt>
          <dd>{{ current.waitingOnServerConnections }}</dd>
        </div>
        @if (showDisk()) {
          <div>
            <dt>{{ 'Disk free' | translate }}</dt>
            <dd>{{ diskAvailableLabel() }}</dd>
          </div>
          <div>
            <dt>{{ 'Disk size' | translate }}</dt>
            <dd>{{ diskTotalLabel() }}</dd>
          </div>
        }
        <div>
          <dt>{{ 'Session visibility' | translate }}</dt>
          <dd>{{ visibilityLabel() | translate }}</dd>
        </div>
      </dl>
      <p class="slot-meta">
        @if (current.generatedAt) {
          {{ current.generatedAt | date: 'medium' }}
        }
      </p>
      @if (ownSessionsOnly()) {
        <p class="visibility-warning">{{ 'Postgres session visibility is limited' | translate }}</p>
      }
    }
  }
</section>
